var upArrowKeyCode = 38;
var downArrowKeyCode = 40;
var enterKeyCode = 13;
var escKeyCode = 27;
export { upArrowKeyCode, downArrowKeyCode, enterKeyCode, escKeyCode };